import { IsNotEmpty, IsString } from 'class-validator';

export class TaxonomyReferenceFieldGetDataRequest {
    @IsString()
    @IsNotEmpty()
    public nameOfFieldReference: string;

    constructor(data?: Partial<TaxonomyReferenceFieldGetDataRequest>) {
        this.nameOfFieldReference = data?.nameOfFieldReference;
    }
}
